function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".partitions-icon{fill:url(#partitions);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "partitions",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 62.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#038FC7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7B00FF"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "partitions-icon",
  d: "m 5.000111,35.872285 0,28.246996 2.897687,0 0,-12.674666 12.674781,0 0,-2.897665 -12.674781,0 0,-12.674665 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "partitions-icon",
  d: "m 48.546842,35.872285 0,12.674665 -12.674781,0 0,2.897665 12.674781,0 0,12.674666 2.897688,0 0,-12.674666 12.674781,0 0,-2.897665 -12.674781,0 0,-12.674665 -2.897688,0 z",
  color: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "partitions-icon",
  d: "m 35.872061,5.0006935 0,2.8976619 12.674781,0 0,12.6746606 2.897688,0 0,-12.6746606 12.674781,0 0,-2.8976619 z",
  color: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "partitions-icon",
  d: "m 5.000111,5.0006935 0,15.5662605 2.888752,-4.42e-4 0,-12.6775339 12.681214,0 8e-5,-2.8882846 z",
  color: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "partitions-icon",
  d: "m 92.11442,35.872285 0,12.674665 -12.674781,0 0,2.897665 12.674781,0 0,12.674666 2.876845,0 0,-28.246996 z",
  color: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "partitions-icon",
  d: "m 94.999995,5 0,15.566259 -2.888743,-4.41e-4 0,-12.6775334 -12.681212,0 L 79.429953,5 z",
  color: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "partitions-icon",
  d: "m 5,95 0,-15.56625 2.888753,4.38e-4 0,12.677527 12.681215,0 L 20.570047,95 z",
  color: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "partitions-icon",
  d: "m 48.546842,79.439404 0,12.674654 -12.674781,0 0,2.876815 28.24725,0 0,-2.876815 -12.674781,0 0,-12.674654 z",
  color: "#000"
}), /*#__PURE__*/React.createElement("path", {
  className: "partitions-icon",
  d: "m 94.999705,94.999042 0,-15.56625 -2.888753,4.39e-4 0,12.677527 -12.681213,0 -8.6e-5,2.888284 z",
  color: "#000"
}));

function SvgPartitions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartitions);
export default __webpack_public_path__ + "static/media/partitions.2b458a9a.svg";
export { ForwardRef as ReactComponent };